import { render, staticRenderFns } from "./Races.vue?vue&type=template&id=1929ba44&scoped=true&"
import script from "./Races.vue?vue&type=script&lang=js&"
export * from "./Races.vue?vue&type=script&lang=js&"
import style0 from "./Races.vue?vue&type=style&index=0&id=1929ba44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929ba44",
  null
  
)

export default component.exports